import React, { useEffect } from 'react';
import { Route, Switch, Redirect, useLocation } from "react-router-dom";

import { Routes } from "./routes";

import { GlobalNavbar } from './components/Navbar';

import Homepage from "./pages/public/Homepage";
import Search from "./pages/public/Search";

import SignIn from "./pages/login/Signin";
import SignUp from "./pages/login/Signup";
import ForgotPassword from "./pages/login/ForgotPassword";

import PropertyInfo from "./pages/public/PropertyInfo";
import ListingInfo from "./pages/public/ListingInfo";

import NotFoundPage from "./pages/errors/NotFound";
import ServerError from "./pages/errors/ServerError";

import DashboardOverview from "./pages/dashboard/DashboardOverview";

import UserProfile from "./pages/dashboard/UserProfile";
import PropertyDetail from "./pages/dashboard/PropertyDetail";
import ListingDetail from "./pages/dashboard/ListingDetail";
import BookingDetail from "./pages/dashboard/BookingDetail";

import GuestDashboard from "./pages/dashboard/GuestDashboard";

import CustomerSupport from "./pages/dashboard/CustomerSupport";

import ProtectedRoute from "./components/auth/protected-route";


const ScrollToTop = (props) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{props.children}</>
};


const PublicRoute = ({ navVariant, component: Component, ...rest }) => {
  return (
    <>
      <GlobalNavbar variant={navVariant} />
      <Route {...rest} render={props => (  <Component {...props} /> ) } />
    </>
  );
}


const App = (props) => (
  <ScrollToTop>
    <Switch>
      <PublicRoute exact path={Routes.Homepage.path} component={Homepage} navVariant="public" />
      <PublicRoute exact path={Routes.Search.path} component={Search} navVariant="public" />

      <PublicRoute exact path={Routes.Signin.path} component={SignIn} navVariant="public" />
      <PublicRoute exact path={Routes.Signup.path} component={SignUp} navVariant="public" />
      <PublicRoute exact path={Routes.ForgotPassword.path} component={ForgotPassword} navVariant="public" />

      <PublicRoute exact path={Routes.NotFound.path} component={NotFoundPage} navVariant="public" />
      <PublicRoute exact path={Routes.ServerError.path} component={ServerError} navVariant="public" />

      <PublicRoute exact path={Routes.PropertyInfo.path} component={PropertyInfo} navVariant="public" />
      <PublicRoute exact path={Routes.ListingInfo.path} component={ListingInfo} navVariant="listingInfo" />

      <ProtectedRoute exact path={Routes.DashboardOverview.path} component={DashboardOverview} />

      <ProtectedRoute exact path={Routes.UserProfile.path} component={UserProfile} />
      <ProtectedRoute exact path={Routes.PropertyDetail.path} component={PropertyDetail} />
      <ProtectedRoute exact path={Routes.ListingDetail.path} component={ListingDetail} />
      <ProtectedRoute exact path={Routes.BookingDetail.path} component={BookingDetail} />

      <ProtectedRoute exact path={Routes.GuestDashboard.path} component={GuestDashboard} />

      <ProtectedRoute exact path={Routes.CustomerSupport.path} component={CustomerSupport} />

      <Redirect to={Routes.NotFound.path} />
    </Switch>
  </ScrollToTop>
);
export default App;
